import type { Brand, Packaging } from '../domain/product';

/** Cor do rótulo por marca, enquanto não há foto do produto. */
const LABEL: Record<Brand, string> = {
  'central-nutrition': 'oklch(0.77 0.14 185)',
  'central-farma': 'oklch(0.62 0.18 295)',
  'central-injetaveis': 'oklch(0.66 0.14 245)',
};

/** Enquadramento justo de cada forma, para todas ocuparem a mesma altura. */
const VIEWBOX: Record<Packaging, string> = {
  pot: '22 12 76 96',
  bottle: '24 8 72 104',
  vial: '30 10 60 100',
  box: '8 18 104 84',
};

/** Ilustração da embalagem. Substituída por `imageUrl` quando houver foto. */
export function ProductImage({ packaging, brand }: { packaging: Packaging; brand: Brand }) {
  const label = LABEL[brand];
  return (
    <svg aria-hidden viewBox={VIEWBOX[packaging]} className="h-full w-auto">
      {packaging === 'pot' && (
        <g>
          <rect x="38" y="20" width="44" height="12" rx="3" fill="#d9dbe0" />
          <rect x="34" y="30" width="52" height="72" rx="8" fill="#f4f5f7" stroke="#e2e4e9" />
          <rect x="34" y="50" width="52" height="30" fill={label} opacity="0.9" />
          <rect x="44" y="58" width="32" height="4" rx="2" fill="white" opacity="0.9" />
          <rect x="48" y="66" width="24" height="3" rx="1.5" fill="white" opacity="0.6" />
        </g>
      )}
      {packaging === 'bottle' && (
        <g>
          <rect x="48" y="14" width="24" height="14" rx="3" fill="#d9dbe0" />
          <path
            d="M44 34 Q44 28 50 28 H70 Q76 28 76 34 V100 Q76 106 70 106 H50 Q44 106 44 100 Z"
            fill="#f4f5f7"
            stroke="#e2e4e9"
          />
          <rect x="44" y="52" width="32" height="34" fill={label} opacity="0.9" />
          <rect x="50" y="62" width="20" height="4" rx="2" fill="white" opacity="0.9" />
          <rect x="53" y="70" width="14" height="3" rx="1.5" fill="white" opacity="0.6" />
        </g>
      )}
      {packaging === 'box' && (
        <g>
          {/* caixa em perspectiva com sachês ao lado */}
          <path d="M14 46 L70 38 L70 96 L14 100 Z" fill="#f4f5f7" stroke="#e2e4e9" />
          <path d="M70 38 L92 46 L92 102 L70 96 Z" fill="#e6e8ec" stroke="#dcdfe4" />
          <path d="M14 46 L36 54 L92 46 L70 38 Z" fill="#fbfbfc" stroke="#e2e4e9" />
          <path d="M14 72 L70 66 L70 84 L14 89 Z" fill={label} opacity="0.9" />
          <rect x="22" y="56" width="30" height="4" rx="2" fill={label} />
          <rect x="94" y="58" width="16" height="40" rx="2" fill="#fbfbfc" stroke="#e2e4e9" />
          <rect x="94" y="78" width="16" height="8" fill={label} opacity="0.9" />
        </g>
      )}
      {packaging === 'vial' && (
        <g>
          <rect x="50" y="16" width="20" height="10" rx="2" fill={label} />
          <rect x="53" y="26" width="14" height="8" fill="#c9ccd3" />
          <path
            d="M48 38 Q48 34 52 34 H68 Q72 34 72 38 V100 Q72 104 68 104 H52 Q48 104 48 100 Z"
            fill="#eef4f8"
            stroke="#dbe3ea"
          />
          <rect x="49" y="70" width="22" height="33" rx="2" fill={label} opacity="0.25" />
          <rect x="48" y="50" width="24" height="16" fill="white" stroke="#dbe3ea" />
          <rect x="52" y="56" width="16" height="3" rx="1.5" fill={label} />
        </g>
      )}
    </svg>
  );
}
